// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createActionsHook, createHook, createSubscriber } from '@atlassian/react-sweet-state';
import Store from '../store.tsx';
import type { State } from '../types.tsx';
import type { Actions } from '../actions/page-events/index.tsx';

/**
 * @deprecated replace with `useSpaState` or `useSpaStateActions`
 */
export const SpaStateSubscriber = createSubscriber<State, Actions>(Store);

export const useSpaState = createHook(Store);

export const useSpaStateActions = createActionsHook(Store);
